/*
 * @Author: ts.r
 * @Date: 2020-11-26 11:26:57
 * @LastEditTime: 2020-11-27 18:02:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cmine-pro-fe/src/apps/index/mixins/download.ts
 */
import { Component, Vue } from 'vue-property-decorator'
import { getSourceAddress } from './../../index/models/api'
@Component
export default class DownloadQuestionsMixin extends Vue {
    public loading = false
    public visible = false
    public async getSource(
        task_id: string | number,
        count: number,
        home?: string
    ) {
            try {
                let { data } = await getSourceAddress(task_id)
                if (data.success) {
                    if (this.loading) {
                        this.loading = false
                    }
                    if ( this.visible) {
                        this.visible = false
                    }
                    let temp = `/question/finish?url=${data.data.download_url}&home=${home}`
                    setTimeout(() => {
                        location.href = temp
                    }, 50)
                } else {
                    if (count > 3000) {
                        if (this.loading) {
                            this.loading = false
                        }
                        if ( this.visible) {
                            this.visible = false
                        }
                        this.$message.warning('请求超时，请重新下载！')
                    } else {
                        count = count + 1
                        // 失败之后1秒以后查询
                        setTimeout(() => {
                            this.getSource(task_id, count, home)
                        }, 1000)
                    }
                }
            } catch (e) {
                if (this.loading) {
                    this.loading = false
                }
                if ( this.visible) {
                    this.visible = false
                }
                console.log(e)
            }
    }
}
